import LabelFilter from './labelFilter';
import RoundFilter from './roundFilter';
import StateFilter from './stateFilter';
import UserAssignedFilter from './userAssignedFilter';
import RatingFilter, { isRatingFilterJSON } from './ratingFilter';
import { FilterJSON, isLabelFilterJSON, isRoundFilterJSON, isUserAssignedFilterJSON } from './types';
import type FilterOption from './filterOption';

export function filterOptionFromJson( json: FilterJSON ): FilterOption | null {
	if ( isLabelFilterJSON( json ) ) {
		return LabelFilter.fromJson( json );
	}

	if ( isUserAssignedFilterJSON( json ) ) {
		return UserAssignedFilter.fromJson( json );
	}

	if ( isRoundFilterJSON( json ) ) {
		return RoundFilter.fromJson( json );
	}

	if ( isRatingFilterJSON( json ) ) {
		return RatingFilter.fromJson( json );
	}

	return StateFilter.fromJson( json );
}
